import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
		this.handleSkipPasswordCheck();
		this.handleInputSelectAll();
		this.handleInputAction();

		const roleDropdown = this.roleDropdown();
		if (!!roleDropdown) {
			this.handleRoleSelect(roleDropdown);
			this.togglePermission(this.roleValue());
		}

		this.toggleInputSelectAll();
    return this;
	}

	// The role/profile picker is the reusable components--dropdown-select
	// component (data-name="user[role]"), which dispatches a `change` event and
	// keeps the value on the selected .dropdown-item + a generated hidden input.
	roleDropdown() {
		return document.querySelector('[data-controller~="components--dropdown-select"][data-name="user[role]"]');
	}

	roleValue() {
		const dropdown = this.roleDropdown();
		if (!dropdown) return '';

		const selected = dropdown.querySelector('.dropdown-item.selected[data-value]');
		if (selected) return selected.dataset.value;

		const hidden = document.querySelector('input[name="user[role]"]');
		return hidden ? hidden.value : '';
	}

	handleSkipPasswordCheck() {
		const checkbox = document.getElementById('skip-password-validation');

		this.togglePasswordsTexts(!checkbox.checked);

		checkbox.addEventListener('click', (ev) => {
			const input = ev.currentTarget;
			this.togglePasswordsTexts(!input.checked);
		});
	}

	handleInputSelectAll() {
		document.querySelectorAll('.permission-select-all').forEach((el) => {
			el.addEventListener('click', (ev) => {
				const input = ev.currentTarget;
				input.closest('ul').querySelectorAll('.permission-action').forEach((inputAction) => {
					inputAction.checked = input.checked;
					this.onInputActionClick(inputAction);
				});
			});
		});
	}

	handleInputAction() {
		document.querySelectorAll('.permission-action').forEach((el) => {
			el.addEventListener('click', (ev) => {
				const inputAction = ev.currentTarget;
				this.updatePermissionSelectAll(inputAction);
				this.onInputActionClick(inputAction);
			});
		});
	}

	handleRoleSelect(dropdown) {
		dropdown.addEventListener('change', () => {
			this.togglePermission(this.roleValue(), true);
		});
	}

	togglePasswordsTexts(toggle) {
		document.querySelectorAll('.password-box').forEach((el) => { el.classList.toggle('hidden', toggle) } )
	}

	togglePermission(value, fromUserAction = false) {
		if (value == null) return;

		const isProfile = value.startsWith('profile:');
		const isCustom = value === 'custom' || isProfile;
		const profileId = isProfile ? value.split(':')[1] : '';

		// Update the hidden profile_id field
		const profileIdField = document.getElementById('user_profile_id');
		if (profileIdField) profileIdField.value = profileId;

		// Show/hide the profile info box
		const profileInfoBox = document.getElementById('profile-info-box');
		if (profileInfoBox) profileInfoBox.classList.toggle('!hidden', !isProfile);

		// On an active role/profile change, load the matching permissions into the
		// cards (embedded as data-permission-keys on the selected item). 'custom'
		// has no preset, so the current selection is kept for free editing; on the
		// initial render (fromUserAction=false) the saved permissions are preserved.
		if (fromUserAction) {
			const presetKeys = this.selectedPermissionKeys();
			if (presetKeys) this.applyPermissionKeys(presetKeys);
		}

		// The permission list is ALWAYS visible (as in the mockup); we only toggle
		// editing: predefined roles stay "locked" (disabled, not submitted), while
		// custom/profile remain editable.
		document.querySelectorAll('.permissions .kt-checkbox input:not(.permission-destroy)').forEach((el) => {
			if (!isCustom)
				return el.disabled = 'disabled';

			if (el.classList.contains('permission-action'))
				this.onInputActionClick(el);

			el.removeAttribute('disabled');
		});
	}

	// Permission keys ("subject_class:action") embedded on the selected dropdown
	// item — the role's (admin → segment, others → Role#permissions) or profile's.
	selectedPermissionKeys() {
		const dropdown = this.roleDropdown();
		const selected = dropdown && dropdown.querySelector('.dropdown-item.selected[data-permission-keys]');
		if (!selected) return null;

		try { return JSON.parse(selected.dataset.permissionKeys); }
		catch (_e) { return null; }
	}

	applyPermissionKeys(permissionKeys) {
		// Step 1: uncheck everything — disable subject_class, re-enable _destroy for existing records
		document.querySelectorAll('.permission-action').forEach(cb => {
			const li = cb.closest('li');
			if (!li) return;
			cb.checked = false;
			const subjectClass = li.querySelector('input.permission-subject-class');
			if (subjectClass) subjectClass.disabled = true;
			const destroyInput = li.querySelector('input.permission-destroy');
			if (destroyInput) destroyInput.removeAttribute('disabled');
		});

		// Step 2: check the permissions provided by the selected role/profile
		document.querySelectorAll('.permission-action').forEach(cb => {
			const li = cb.closest('li');
			if (!li) return;
			const subjectClassInput = li.querySelector('input.permission-subject-class');
			if (!subjectClassInput) return;
			const key = `${subjectClassInput.value}:${cb.value}`;
			if (!permissionKeys.includes(key)) return;
			cb.checked = true;
			subjectClassInput.removeAttribute('disabled');
			const destroyInput = li.querySelector('input.permission-destroy');
			if (destroyInput) destroyInput.disabled = true;
		});

		this.toggleInputSelectAll();
		// We checked the boxes via JS (no native event); notify the UI so the
		// permission counters (users--edit controller) recompute.
		this.element.dispatchEvent(new Event('change', { bubbles: true }));
	}

	toggleInputSelectAll() {
		document.querySelectorAll('.permission-select-all').forEach((el) => {
			this.updatePermissionSelectAll(el);
		});
	}

	onInputActionClick(inputAction) {
		const li = inputAction.closest('li');
		if (!li) return;
		const subjectClass = li.querySelector('input.permission-subject-class');
		const destroyInput = li.querySelector('input.permission-destroy');

		if (inputAction.checked) {
			if (subjectClass) subjectClass.removeAttribute('disabled');
			if (destroyInput) destroyInput.disabled = true;
		} else {
			if (subjectClass) subjectClass.disabled = true;
			if (destroyInput) destroyInput.removeAttribute('disabled');
		}
	}

	updatePermissionSelectAll(inputAction) {
		const ul = inputAction.closest('ul');
		const total = ul.querySelectorAll('input.permission-action').length;
		const checked = ul.querySelectorAll('input.permission-action:checked').length;
		const selectAll = ul.querySelector('.permission-select-all');

		selectAll.checked = total === checked;
		selectAll.indeterminate = checked > 0 && checked < total;
	}
}